exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read_only[data-v-e4e652e4]{background-color:#f7f7f7!important;border-color:#f7f7f7!important;color:#262626!important}.accordion .read_only[data-v-e4e652e4]{background-color:#fcfcfc!important}.read_only[data-v-e4e652e4]::-moz-placeholder{color:transparent!important}.read_only[data-v-e4e652e4]::placeholder{color:transparent!important}", ""]);

// exports
